/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

class PipelineSearchSlogan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.screenRatio = 1;
    if (typeof window !== 'undefined') {
      this.screenRatio = document.body.clientWidth / 375;
    }
  }

  componentDidMount() {}

  handleItemClick = (link) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link,
        props: this.props,
      })
      return
    }
    if (!link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link,
      type: baseConfig.sortType,
    };

    const convertUrl = utils.convertHref(link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,link, options, -1,this.props,false);

  }

  render() {
    const { baseConfig } = this.props.config;
    let moreText = baseConfig.moreText || '';
    if (moreText.length > 4) {
      moreText = moreText.slice(0, 4);
    }
    return (
      <div
        className="pipeline-search-slogan"
        {...this.props['customAttributes']}
        onClick={this.handleItemClick.bind(this, baseConfig.moreUrl)}
        style={{
          marginTop: px2rem('12px', false),
          marginBottom: px2rem('9px', false),
          marginLeft: px2rem('12px', false),
          marginRight: px2rem('12px', false),
          height: px2rem('36px', false),
        }}
      >
        <img className="logo-title" src={utils.formatImgUrl(baseConfig.titleImg, this.props.webpSupport)} style={{ width: px2rem('36px', false), height: px2rem('36px', false) }} alt="" />
        <div className="title-content" style={{ width: px2rem('190px', false), paddingLeft: px2rem('8px', false), paddingRight: px2rem('20px', false) }}>
          <div className="title-1" style={{ height: px2rem('22px', false), fontSize: px2rem('16px', false), lineHeight: px2rem('22px', false) }}>{baseConfig.title}</div>
          <div className="title-2" style={{ height: px2rem('12px', false), fontSize: px2rem('10px', false), lineHeight: px2rem('12px', false), }}>{baseConfig.subTitle}</div>
        </div>
        <div className='more-link absolute' style={{ height: px2rem('18px', false) }}>
          <div className="more-text" style={{ height: px2rem('18px', false), fontSize: px2rem('13px', false) }}>{moreText}</div>
          <img className="more-icon" style={{ width: px2rem('10px', false), height: px2rem('10px', false), marginLeft: px2rem('4px', false), marginBottom: utils.isAndroid() ? px2rem('4px', false) : px2rem('1px', false) }} src="https://static.shihuocdn.cn/admin/files/20211117/52ab5967e063a6296546a9ecadba0161.png" alt="" />
        </div>
      </div>
    );
  }
}

PipelineSearchSlogan.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSearchSlogan };
export default PipelineSearchSlogan;



// WEBPACK FOOTER //
// ./components/pipeline-searchSlogan/index.js